import React, {useEffect, useState} from "react";
import reviewService from "../services/ReviewService";
import {Link} from "react-router-dom";
import axios from "axios";

// Fetches reviews of the restaurant using restaurant Id.
const DetailsList = ({hotelId}) => {
    const[reviews, setReviews] = useState([]);
    const[user, setUser] = useState("");

    //using axios for easy fetching
    useEffect( () =>{
        axios.get('  https://food-mafia-server.herokuapp.com/api/checkLogin').
        then(response => {
            if(response.data.name){
                setUser(response.data.userId)
            }
        });
    }, []);


    const deleteReview = (review) => {
        reviewService.deleteReview(review._id)
            .then(() => setReviews(
                reviews.filter(r => r !== review)
            ));
    }

    useEffect(() =>
        reviewService.findAllReviews(hotelId)
            .then(reviews => setReviews(reviews)));

    return(
        <div className="col-8">
            {
                reviews.map( review =>
                    <div className="wd-row m-3 p-3">
                        <div className="wd-col-twentyPercent col-sm-2 col-md-2 col-lg-2 col-xl-1 col-xxl-1">
                            <img src="https://i.picsum.photos/id/365/5616/3744.jpg?hmac=m9Chefr19BelgN9G4ErJVFBbdvNmA_xlbd0CjATLwhM"
                                 className="img-fluid wd-main-image" alt = "profilePic"/>
                        </div>
                        <div className="wd-col-eightyPercent col-10">
                            <div className="wd-author">
                                <Link to={`/userProfile/${review.userId}`}>
                                    <p id="author-name"><b>{review.name}</b></p>
                                </Link>
                                {
                                    user === review.userId &&
                                    <button type="button" className="btn btn-info" onClick={() => deleteReview(review)} style={{float:"right"}}>Delete</button>
                                    // <i className="fas fa-times" onClick={() => deleteReview(review)} style={{float:"right"}}></i>
                                }
                            </div><br/>
                            <div className="wd-content">
                                <p> {review.desc} </p>
                            </div>
                        </div>
                    </div>

                )
            }
        </div>
    );
}

export default DetailsList;